import { getFoundKeysOnObject } from '@/utilities.helpers.js'

export default {
  methods: {
    /**
     * Obtiene los valores de determinadas propiedades del objeto 'objectToSearchInData' en el objeto `this.data` de este componente. Los valores encontrados se adjuntan a los valores en baseObject cuyas llaves coincidan.
     * @param {String} objectToSearchInData - Indica el nombre de la propiedad dentro de `this.data` que debe evaluarse. La propiedad debe de tener un tipo de valor igual a 'object'
     * @param {Object} baseObject - Objeto cuyas llaves se usan como diccionario para encontrar los valores en `objectToSearchInData`, y cuyos valores seran fusionados con los encontrados.
     * @returns {Array<Object>} - Retorna una lista de los valores encontrados adjuntados al valor coincidente de baseObject.
     */
    getPropertiesIfExistFromDataObject(objectToSearchInData, baseObject) {
      // Obtenemos el objeto dentro de `this.data` que debemos evaluar
      const objectToSearch = this[objectToSearchInData]
      // El diccionario es la lista de propiedades que queremos encontrar en `objectToSearch`
      const dictionary = Object.keys(baseObject)
      // Obtenemos el valor de las propiedades en el objeto en cuestion.
      const foundCategoryValues = getFoundKeysOnObject(objectToSearch, dictionary, true)
      // Adjuntamos los valores encontrados a los valores originales
      return dictionary.reduce((accumulatorArray, dictProperty) => {
        if (foundCategoryValues.hasOwnProperty(dictProperty)) {
          accumulatorArray.push({
            ...baseObject[dictProperty],
            found_value: foundCategoryValues[dictProperty],
          })
        }
        return accumulatorArray
      }, [])
    },
  },
}
